<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item">
        <a class=" text-decoration-none" routerLink="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               class="bi bi-house-door-fill" viewBox="0 0 16 16">
            <path
              d="M6.5 14.5v-3.505c0-.245.25-.495.5-.495h2c.25 0 .5.25.5.5v3.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5"/>
          </svg>
          <span jhiTranslate="global.menu.home">news</span>
        </a>
      </li>

      <li class="breadcrumb-item active text-secondary" aria-current="page">
        11.2.2017
      </li>
    </ol>
  </nav>
  <div class="row">
    <div class="col">
      <h3 class="mb-0 text-primary">Lehrauftrag an der FHS St. Gallen</h3>
      <div class="mb-1 text-body-secondary">11.2.2017</div>
      <p class="mb-auto">Seit Januar 2017 unterstützen wir an der Fachhochschule St. Gallen das Wahlpflicht Modul <q>Sexualität & Sexualpädagogik</q> mit einem themenspezifischen Referat dazu. Anschliessend können die Studenten von einer direkten Fragen- und Diskussionsrunde profitieren.</p>
    </div>
    <div class="col-auto h d-lg-block">
      <div class="col-auto h d-lg-block">
        <img src="/../../../content/blog/blog2_1.jpg" alt="sexcare bild"  width="250">
      </div>
    </div>
  </div>
</div>
